import { render, staticRenderFns } from "./PTab.vue?vue&type=template&id=7b20d122"
import script from "./PTab.vue?vue&type=script&lang=js"
export * from "./PTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports